<template>
  
  <div class="content-wrap">
    <div class="search-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-4">
            <ElLabel name="회사명">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.cmp_nm" @inputKeyupEnter="searchCompany()"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-4">
            <ElLabel name="사업부명">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.cmp_dvsn_nm" @inputKeyupEnter="searchCompany()"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-4">
            <ElLabel name="사업자번호">
              <template #end="{id}">
                <ElInput 
                  :id="id"
                  ref="businessNoRef"
                  v-model="state.searchParams.business_no" 
                  :maxlength='12' 
                  @update:modelValue="bizNoFormat" 
                  @inputKeyupEnter="searchCompany()"
                 />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-4">
             <ElLabel name="사업자/개인 구분">
              <template #end>
                <ElSelect v-model="state.searchParams.account_type" :options="state.bpTypeList"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
    </div>
    <div class="search-detail-wrap"></div>

    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="searchCompany()">
        검색
      </ElButton>
    </div>

    <div class="d-flex justify-content-between">
      <div></div>
      <div class="table-btn-group">
        <ElButton
          type="excelDownload"
          @buttonClick="excelDownload()"
        >
          엑셀다운
        </ElButton>
      </div>
    </div>

    <div class="table-responsive table-list">
      <DataTable
        :value="state.gridRowData"
        paginator
        :rows="20"
        selectionMode="single"
        :rowsPerPageOptions="[10, 20, 50, 100, 200]"
        @rowSelect="onRowSelect"
        :pt="{
          input : {class:'form-check-input'},
          column: {
              bodycell: ({ state }) => ({
                  class: [{ 'pt-0 pb-0': state['d_editing'] }]
              })
          }
        }"
      >
      <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>
        <Column :style="'maxWidth: 10px;'">
          <template #header>
              <ElCheckbox v-model="allCheck"/>
          </template>
          <template #body="{ data }">
              <ElCheckbox 
              v-model="state.selectRows" 
              :value="data"
              />
          </template>
        </Column>
        <Column
          v-for="(company,index) of state.gridColumn"
          :key="index"
          :field="company.field"
          :header="company.headerName"
          :style="company.style"
        >
        <template #body="{ data,field }"  >
          <span v-if="company.field == 'cmp_nm'" v-bind:title="data.cmp_nm">{{ getSummaryData(data.cmp_nm) }}</span>
          <span v-else-if="company.field == 'cmp_dvsn_nm'" v-bind:title="data.cmp_dvsn_nm">{{ getSummaryData(data.cmp_dvsn_nm) }}</span>
          <div v-else-if="company.field == 'bkmark_yn'">
            <ElButton
                  type='bookmarkS'
                  disabled
                  :active="data.bkmark_yn == 'Y'"
            ></ElButton>
          </div>
          <span v-else>{{ data[field] }}</span>
        </template>
        </Column>
      </DataTable>
    </div>

    <div class="text-end py-3">
      <ElButton v-if="canUpdate" type="primary" @buttonClick="moveToPage('MCP_CR_001')">
        신규등록
      </ElButton>
      <ElButton type="primary" @buttonClick="shareToUser()">공유하기</ElButton>
    </div>
  </div>
  <!-- 메일발송 모달 (1.컴포넌트) -->
  <EmailSendModal ref="emailSendModalRef" />
  <ExcelManage v-show="false" ref="excelManage" />
</template>

<script setup>
import { reactive, ref, onBeforeMount, computed } from "vue";
import ExcelManage from "@/components/common/MCO_EX_001.vue";
import { useRouter } from "vue-router";
import vueRouterCmn from "@/js/vueRouterCmn";
import common from "@/js/common";

import DataTable from "primevue/datatable";
import Column from "primevue/column";

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { compList } from "@/api/comp";
/** 메일발송 모달 (2.컴포넌트 import 및 참조 선언) */
import EmailSendModal from "@/components/common/modal/EmailSendModal.vue"; 
const emailSendModalRef = ref();

const router = useRouter();

const excelManage = ref();
const businessNoRef = ref();
//수정권한으로 row클릭시 상세조회/수정페이지 이동 분기처리
const canUpdate = computed(()=>{
    return common.checkAccessAuth('M003M002M001')
})
onBeforeMount(() => {
  searchCompany();
});

const state = reactive({
  selectRows: [],
  gridColumn: [
    { headerName: "", field: "bkmark_yn", style:{textAlign : 'center',maxWidth:'20px'} },
    { headerName: "회사명", field: "cmp_nm" },
    { headerName: "사업부명", field: "cmp_dvsn_nm" },
    { headerName: "사업자등록번호", field: "business_no" },
    { headerName: "사업자/개인 구분", field: "account_type" },
    { headerName: "대표자", field: "ceo_nm", style:{textAlign : 'center',minWidth:'35px',maxWidth:'50px'} },
    { headerName: "등록일시", field: "fmt_reg_dt" , style:{textAlign : 'center',maxWidth:'70px'}},
  ],
  excelGridColumn: [
    { headerName: "즐겨찾기", field: "bkmark_yn"},
    { headerName: "회사명", field: "cmp_nm" },
    { headerName: "사업부명", field: "cmp_dvsn_nm" },
    { headerName: "사업자등록번호", field: "business_no" },
    { headerName: "이메일", field: "email" },
    { headerName: "사업자/개인 구분", field: "account_type" },
    { headerName: "대표자", field: "ceo_nm"},
    { headerName: "등록일시", field: "fmt_reg_dt"},
  ],
  gridRowData: [],
  selectRow: null,
  searchParams: {
    cmp_nm: "",
    cmp_dvsn_nm: "",
    business_no: "",
    page_count: 1,
    unit_count: 100000,
    account_type: null,
  },
  bpTypeList:[
    { text: '전체', value: null },
    { text: '사업자', value: 1 },
    { text: '개인', value: 2 },
  ],
});

const allCheck = computed({
  get() {
    return state.gridRowData.length === state.selectRows.length;
  },
  set(newValue) {
    state.selectRows = newValue
      ? state.gridRowData.map((item) => {
        return item;
        })
      : [];
  },
});

//사업자번호 형식 체크
const bizNoFormat = (no) => {
  no = common.checkOnlyNumber(no)
  state.searchParams.business_no = common.bizNoFormat(no);
  businessNoRef.value.input.value = common.bizNoFormat(no);
};


const searchCompany = async () => {
  try {
    setIsLoading(true)
    const res = await compList(state.searchParams)
    state.gridRowData = res.rtn.map((item,index)=>{
      item.index = index+1
      if(item.account_type == 1){
        item.account_type ='사업자'
      }
      if(item.account_type == 2){
        item.account_type ='개인'
      }
      return item
    });
  } catch (err) {
    console.log("/comp/compList ERROR!! => " + err);
    alert("api 에러 발생!!");
  } finally {
    setIsLoading(false)
  }
};

// tommy

const getSummaryData = (item) => {
  let summaryData = item.length > 20 ? item.slice(0,20)+" ..." : item;
  return summaryData
}


const excelDownload = () => {
  let fileNm = "회사 리스트";
  let header = [...state.excelGridColumn];
  let dataList = state.gridRowData;

  if (state.selectRows?.length > 0) {
    dataList = state.selectRows;
  }
  excelManage.value.excelDownload(fileNm, header, dataList);
};

//MCP_CR_001
const moveToPage = (routerName) => {
  vueRouterCmn.routerPush(routerName);
};

const onRowSelect = (event) => {
  if(canUpdate.value){
    vueRouterCmn.routerPush("MCP_CR_003", { cp_seq: event.data.cp_seq });
  }else{
    vueRouterCmn.routerPush("MCP_CR_004", { cp_seq: event.data.cp_seq });
  }
};

//공유하기
const shareToUser = () => {
  openEmailSend();
}

/** 메일발송 모달 (3.팝업오픈) */
const openEmailSend = () => {
  //메일정보 초기값
  const emailParams = {
    call_prgm_id : 'MCP_CR_002',
    call_prgm_nm : '회사 조회/수정',
    receiver_ids : '',
    receiver_nms : '',
    title : '회사 정보 공유드립니다.',
    content : makeEmailContent()
  };

  emailSendModalRef.value.openEmailModal(emailParams);
};

/** 메일발송 모달 (4.메일내용) */
const makeEmailContent = () => {
  //선택된 회사의 목록
    //메일 내용 만들기
    let content = '';
    for (let company of state.selectRows) {
      content += `<b>회사명 : ${company.cmp_nm} / ${company.cmp_dvsn_nm}</b>,사업자등록번호: ${company.business_no}, 대표자: ${company.ceo_nm}<br/>`;
    }
    return content;
  
}

</script>
